import { Box, Typography } from "@mui/material";

import logoLogin123Zap from "../../../shared/assets/brand/logo-login-123zap.png";

export default function AuthFormHeader({ title, description }) {
  return (
    <Box sx={{ mb: { xs: 2.5, md: 3.5 } }}>
      <Box
        component="img"
        src={logoLogin123Zap}
        alt="123zap"
        sx={{
          display: "block",
          height: "auto",
          mb: { xs: 3, md: 4 },
          width: { xs: 68, md: 74 },
          "@media (max-height: 620px)": {
            mb: 2,
            width: 58,
          },
        }}
      />

      <Typography
        component="h2"
        sx={(theme) => ({
          color: theme.palette.text.primary,
          fontSize: {
            xs: theme.typography.h4.fontSize,
            sm: theme.typography.h3.fontSize,
          },
          fontWeight: 800,
          letterSpacing: 0,
          lineHeight: 1.25,
        })}
      >
        {title}
      </Typography>

      <Typography
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          fontSize: { xs: 15, lg: 16 },
          lineHeight: 1.5,
          mt: { xs: 2.5, md: 3.5 },
          "@media (max-height: 620px)": {
            mt: 1.5,
          },
        })}
      >
        {description}
      </Typography>
    </Box>
  );
}
